import { render, staticRenderFns } from "./orders-echart.vue?vue&type=template&id=5ac22c8e&scoped=true&"
import script from "./orders-echart.vue?vue&type=script&lang=js&"
export * from "./orders-echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac22c8e",
  null
  
)

export default component.exports